// Data the post menu needs before it opens: on touch screens the menu is a modal
// that shows the entries as they were at the moment of opening, so loading them
// on click would be too late.
//
// Relationships are collected while a timeline renders and fetched in one request.
// The followed hashtags are fetched once per page load.

import { fetchRelationships } from "flavours/glitch/actions/accounts";
import { fetchFollowedHashtags } from "flavours/glitch/actions/tags";

const BATCH_DELAY = 150;

const pending = new Set();
let timer = null;
let followedTagsRequested = false;

export const prefetchRelationship = (dispatch, id) => {
  if (!id) {
    return;
  }

  pending.add(id);

  if (!timer) {
    timer = setTimeout(() => {
      const ids = [...pending];
      pending.clear();
      timer = null;
      dispatch(fetchRelationships(ids));
    }, BATCH_DELAY);
  }
};

export const prefetchFollowedTags = (dispatch) => {
  if (followedTagsRequested) {
    return;
  }

  followedTagsRequested = true;
  dispatch(fetchFollowedHashtags());
};
